import find from 'lodash/find';
import { findTagIndex } from './tags';

const getCarpetOption = (options) => (options
  ? find(options, (option) => option && option.tags && findTagIndex(option.tags, 'carpet:primaryOption') > -1)
  : null);

const getSelectedCarpetChoice = (options, choices) => {
  const carpetOption = getCarpetOption(options);
  return choices && carpetOption
    ? find(choices, (choice) => choice.optionId === carpetOption.id && choice.isSelected)
    : null;
};

export default getSelectedCarpetChoice;
